import initData from 'init-data';
import actions from '../actions/my-tradera';
import uiReducers from 'tradera-state/ui/reducer';
import CONSTANTS from 'tradera-constants/state';

const defaultState = {
    isSearching: false,
    page: {},
    error: false,
    initData: {
        environment: initData.environment || '',
        version: initData.environment || '',
        title: initData.title || '',
        description: initData.description || ''
    },
    splitTests: initData.splitTests || null,
    memberAlias: initData ? initData.memberAlias : '',
    memberFirstName: initData ? initData.memberFirstName : '',
    memberId: initData ? initData.memberId : '',
    memberLastName: initData ? initData.memberLastName : '',
    memberCountryCodeIso2: initData ? initData.memberCountryCodeIso2 : null,
    memberMessagingParticipation: false,
    mobileMenu: false,
    mobileActions: false,
    selected: null,
    isUpdatingNewShippingPrice: false,
    messagingModal: {
        open: CONSTANTS.MODAL.CLOSED,
        title: '',
        src: '',
        participating: false,
        recipientId: '',
        item: null
    }
};

export default (state = defaultState, action) => {
    const searching = () => ({
        ...state,
        isSearching: action.payload
    });

    const error = () => ({
        ...state,
        error: action.payload
    });

    const hideNotifications = () => ({
        ...state,
        hideNotifications: action.payload
    });

    const openModal = () => ({
        ...state,
        openModal: action.payload === false ? false : action.payload
    });

    const setBreakPoint = () => ({
        ...state,
        breakpoint: action.payload
    });

    const mobileMenu = () => ({
        ...state,
        mobileMenu:
            action.payload && action.payload === false
                ? false
                : !state.mobileMenu
    });

    const mobileActions = () => ({
        ...state,
        mobileActions:
            action.payload && action.payload === false
                ? false
                : !state.mobileActions
    });

    const setSelected = () => ({
        ...state,
        selected: action.payload
    });

    const updatingNewShippingPrice = () => ({
        ...state,
        isUpdatingNewShippingPrice: action.payload
    });

    const setMemberMessagingParticipation = () => ({
        ...state,
        memberMessagingParticipation: action.payload
    });

    /*
    Reusing actions and reducers for messaging modal from global
    redux store to reduce duplicate code
    */
    const openMessagingModal = () => uiReducers(state, action);

    const closeMessagingModal = () => uiReducers(state, action);

    const setTranslatedRouteInformation = () => ({
        ...state,
        page: action.payload
    });

    const def = () => state;

    const reducers = {
        [actions.actionTypes.SEARCHING]: searching,
        [actions.actionTypes.HIDE_NOTIFICATIONS]: hideNotifications,
        [actions.actionTypes.ERROR]: error,
        [actions.actionTypes.OPEN_MODAL]: openModal,
        [actions.actionTypes.SET_BREAKPOINT]: setBreakPoint,
        [actions.actionTypes.SET_SELECTED]: setSelected,
        [actions.actionTypes.MOBILE_MENU]: mobileMenu,
        [actions.actionTypes.MOBILE_ACTIONS]: mobileActions,
        [actions.actionTypes
            .UPDATING_NEW_SHPPING_PRICE]: updatingNewShippingPrice,
        [actions.actionTypes
            .SET_MEMBER_MESSAGING_PARTICIPATION]: setMemberMessagingParticipation,
        [actions.actionTypes.OPEN_MESSAGING_MODAL]: openMessagingModal,
        [actions.actionTypes.CLOSE_MESSAGING_MODAL]: closeMessagingModal,
        [actions.actionTypes
            .SET_TRANSLATED_ROUTE_INFORMATION]: setTranslatedRouteInformation
    };

    return !reducers[action.type] ? def() : reducers[action.type]();
};

export const selectMyTraderaState = state => state.views.myTradera.myTradera;
